import { getRequest } from "../utils/axios";

export const publicDatasetsService = {
  list: (onSuccess, onError) => getRequest("/api/v1/public-datasets/", onSuccess, onError),
};
